(() => {
  if (window.melodyDesignNavigationV2) return;
  window.melodyDesignNavigationV2 = true;
  const animatePanel = (panel, open) => {
    if (!panel) return;
    const from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
    panel._melodyAnimation?.cancel();
    panel.hidden = false;
    const to = open ? Math.min(panel.scrollHeight, innerHeight * .7) : 0;
    panel.style.overflow = 'hidden';
    const animation = panel.animate([{height:from+'px',opacity:from ? 1 : 0},{height:to+'px',opacity:open ? 1 : 0}],{duration:matchMedia('(prefers-reduced-motion: reduce)').matches?0:280,easing:'cubic-bezier(.22,.61,.36,1)'});
    panel._melodyAnimation = animation;
    animation.finished.then(() => {
      if(panel._melodyAnimation !== animation) return;
      panel.hidden = !open;
      panel.style.overflow = '';
      panel._melodyAnimation = null;
    }).catch(() => {});
  };
  const setOpen = (menu, open) => {
    menu.classList.toggle('is-open', open);
    menu.querySelector('.ml-menu-toggle')?.setAttribute('aria-expanded', String(open));
    animatePanel(menu.querySelector('.ml-dropdown'), open);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('.ml-rug-toggle');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const open = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', String(open));
    animatePanel(button.closest('.ml-rug-menu').querySelector('.ml-rug-submenu'), open);
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest('.ml-menu-toggle');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const menu = button.closest('.ml-mobile-menu');
    if (menu) setOpen(menu, button.getAttribute('aria-expanded') !== 'true');
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('.ml-header a');
    document.querySelectorAll('.ml-mobile-menu.is-open').forEach(menu => {
      if (link || !menu.contains(event.target)) setOpen(menu, false);
    });
    document.querySelectorAll('.ml-nav details[open]').forEach(menu => {
      if (link || !menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ml-mobile-menu.is-open').forEach(menu => {
      setOpen(menu, false);
      menu.querySelector('.ml-menu-toggle')?.focus();
    });
    document.querySelectorAll('.ml-nav details[open]').forEach(menu => { menu.open = false; });
  });
})();

(() => {
  if (customElements.get('melody-dimension-picker')) return;
  class MelodyDimensionPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.pairs = [...this.querySelectorAll('[data-dimension-source]')].map(link => {
        const match = link.dataset.size.match(/(\d+(?:[.,]\d+)?)\s*[×xX*]\s*(\d+(?:[.,]\d+)?)/);
        if (!match) return null;
        const dims = match.slice(1).map(n => Number(n.replace(',', '.'))).sort((a,b) => a-b);
        return dims.every(n => n > 0) ? {width:dims[0],length:dims[1],url:link.getAttribute('href')} : null;
      }).filter(Boolean).sort((a,b) => a.width-b.width || a.length-b.length);
      this.pairs = this.pairs.filter((p,i,a) => a.findIndex(q => q.width===p.width && q.length===p.length)===i);
      if (!this.pairs.length) return;
      this.form = this.querySelector('form');
      this.widthField = this.querySelector('[data-width]');
      this.lengthField = this.querySelector('[data-length]');
      [...new Set(this.pairs.map(p => p.width))].forEach(w => this.widthField.add(new Option(String(w),String(w))));
      if (this.pairs.some(p => p.width===200)) this.widthField.value = '200';
      this.updateLengths();
      if ([...this.lengthField.options].some(o => o.value==='300')) this.lengthField.value = '300';
      this.widthField.addEventListener('change', () => this.updateLengths());
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        const pair = this.pairs.find(p => p.width===Number(this.widthField.value) && p.length===Number(this.lengthField.value));
        if (!pair) return;
        const url = new URL(pair.url, location.origin);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        location.assign(url.href);
      });
      const shortcuts = this.querySelector('[data-shortcuts]');
      const preferred = this.pairs.filter(p => [150,200,250].includes(p.width));
      (preferred.length ? preferred : this.pairs).slice(0,3).forEach(pair => {
        const link = document.createElement('a');
        link.href = pair.url;
        link.textContent = `${pair.width} × ${pair.length} cm`;
        shortcuts.append(link);
      });
      this.querySelector('.ml-dimension-sources').hidden = true;
      this.form.hidden = false;
    }
    updateLengths() {
      const previous = this.lengthField.value;
      this.lengthField.replaceChildren();
      this.pairs.filter(p => p.width===Number(this.widthField.value)).forEach(p => this.lengthField.add(new Option(String(p.length),String(p.length))));
      if ([...this.lengthField.options].some(o => o.value===previous)) this.lengthField.value = previous;
    }
  }
  customElements.define('melody-dimension-picker', MelodyDimensionPicker);
})();


(() => {
  if (window.melodyInlineSearch) return;
  window.melodyInlineSearch = true;
  const closeSearch = dialog => {
    if (!dialog.open || dialog._closing) return;
    dialog._closing = true;
    const motion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    dialog.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-10px)'}],{duration:motion?0:160,easing:'ease-in'}).finished.then(() => {dialog.close();dialog._closing=false;});
  };
  document.addEventListener('click', event => {
    const toggle=event.target.closest('.ml-search-toggle');
    if(toggle){
      const dialog=document.getElementById(toggle.getAttribute('aria-controls'));
      if(!dialog)return;
      event.preventDefault();
      if(dialog.open)return;
      dialog._trigger=toggle;
      dialog._bodyOverflow=document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow='hidden';
      dialog.querySelector('input[type=search]')?.focus();
      if(!dialog._bound){
        dialog.addEventListener('close',()=>{document.body.style.overflow=dialog._bodyOverflow||'';dialog._closing=false;dialog._trigger?.focus();});
        dialog.addEventListener('cancel',event=>{event.preventDefault();closeSearch(dialog);});
        dialog._bound=true;
      }
      return;
    }
    const close=event.target.closest('.ml-search-close');
    if(close){closeSearch(close.closest('dialog'));return;}
    if(event.target.matches('.ml-search-dialog')){
      const rect=event.target.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)closeSearch(event.target);
    }
  });
})();
